log = require 'loglevel'
BaseManager = require 'BaseManager'

###############################################

class LoadingManager extends BaseManager

  name: 'LoadingManager'
  debug: false
  hasStarted: false
  container: null
  bar: null
  bg: null
  label: null
  percent: 0
  queue: []
  isProcessingQueue: false
  doneDelay: 3000
  incDelay: 20

  # -------------------------------------------

  constructor: ->
    log.info @name, 'constructor' if @debug

  # -------------------------------------------

  start: ->

    unless @container?
      @container = document.getElementById 'progress-container'

      @bg = document.createElement("div")
      @bg.id = 'progress-bg'
      @container.appendChild @bg

      @bar = document.createElement("div")
      @bar.id = 'progress-bar'
      @bg.appendChild @bar

      @label = document.createElement("p")
      @label.id = 'progress-percent'
      @label.innerHTML = "#{@percent}%";
      @container.appendChild @label

    @bar.style.display = 'block'

    @hasStarted = true

  # -------------------------------------------

  done: ->
    setTimeout( =>
      @percent = 0
      @bar.style.display = 'none'
      @bar.style.width = "#{@percent}%"
      @label.innerHTML = "#{@percent}%"
    , @doneDelay)

    @hasStarted = false

  # -------------------------------------------

  set: (amount) ->
    return unless @hasStarted
    @queue.push amount
    @processQueue() unless @isProcessingQueue

  # -------------------------------------------

  processQueue: ->

    if @queue.length is 0
      @isProcessingQueue = false
      return

    @isProcessingQueue = true

    amount = @queue.shift()
    @percent = amount * 100

    log.info @name, 'percent', @percent if @debug

    @queueTimer = setTimeout( =>
      @percent = 100 if @percent >= 100
      @bar.style.width = "#{@percent}%"
      @label.innerHTML = "#{Math.round(@percent)}%"

      if @queue.length is 0
        if @percent is 100
          @onComplete() if @onComplete?

      @processQueue()

    , @incDelay)

  # -------------------------------------------

  increment: ->
    @set @percent + (0.1 * @percent)

  # -------------------------------------------

  hideInitialLoader: ->
    log.info @name, 'hideInitialLoader' if @debug

    @done()
    @queue = []
    clearTimeout(@queueTimer)

    ele = document.getElementById 'initial-loader'
    ele.style.opacity = 0
    ele.style.display = 'none'
    setTimeout( ->
      ele.parentNode.removeChild ele
    , 1000)

  # -------------------------------------------

module.exports = LoadingManager.getInstance()



// WEBPACK FOOTER //
// ./coffee/manager/loading-manager.coffee